export enum AppRoutes {
  AUTH = 'auth',
  EVENTS = 'events',
  EVENT_CREATE = 'event_create',
  EVENT_DETAILS = 'event_details',
  QR = 'qr',
  INVITE = 'invite',
  FORM = 'form',
  QR_ADMIN = 'qr_admin',
  ERROR = 'error',
  ERROR_QR_REMOTE = 'error_qr_remote',
  UNCAUGHT_ERROR = 'uncaught_error',
  UNKNOWN_ERROR = 'unknown_error',
  NOT_FOUND = 'not_found',
}

export const getRouteAuth = () => '/auth';
export const getRouteEvents = () => '/';
export const getRouteEventCreate = () => '/new-event';
export const getRouteEventDetails = (id: string) => `/events/${id}`;
export const getRouteQr = (id: string) => `/qr/${id}`;
export const getRouteInvite = (hash: string) => `/invite/${hash}`;
export const getRouteForm = (hash: string) => `/form/${hash}`;
export const getRouteQrAdmin = (hash: string) => `/qr-moderator/${hash}`;
export const getRouteError = () => '/error';
export const getRouteErrorQrRemote = () => '/error-for-remote';
export const getRouteUncaughtError = () => '/uncaught-error';
export const getRouteUnknownError = () => '/unknown-error';
